module.exports = __webpack_public_path__ + "img/play-circle.c4e422db.svg";